import { Component, inject, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HomeService } from '../home.service';
import { FilterService } from '../../../util/filters/filter.service';
import { APP_FILTER_SERVICE_CONFIG } from '../../../util/filters/filter.interfaces';
import { RouterService } from '../../../util/router/router.service';
import { CourseCatalogueLocationFilterComponent } from '../../courses/course-catalogue/course-catalogue-filter/course-catalogue-location-filter/course-catalogue-location-filter.component';
import { CourseCataloguePeriodFilterComponent } from '../../courses/course-catalogue/course-catalogue-filter/course-catalogue-period-filter/course-catalogue-period-filter.component';
import { CourseCatalogueAgeFilterComponent } from '../../courses/course-catalogue/course-catalogue-filter/course-catalogue-age-filter/course-catalogue-age-filter.component';
import { CourseCatalogueThemeCategoryFilterComponent } from '../../courses/course-catalogue/course-catalogue-filter/course-catalogue-theme-category-filter/course-catalogue-theme-category-filter.component';
import { CourseCatalogueThemeFilterComponent } from '../../courses/course-catalogue/course-catalogue-filter/course-catalogue-theme-filter/course-catalogue-theme-filter.component';

@Component({
  selector: 'app-hero-section',
  standalone: true,
  imports: [
    FormsModule,
    CourseCatalogueLocationFilterComponent,
    CourseCataloguePeriodFilterComponent,
    CourseCatalogueAgeFilterComponent,
    CourseCatalogueThemeCategoryFilterComponent,
    CourseCatalogueThemeFilterComponent,
  ],
  templateUrl: './hero-section.component.html',
  providers: [
    HomeService,
    FilterService,
    {
      provide: APP_FILTER_SERVICE_CONFIG,
      useValue: {
        key: 'course-catalogue-filter',
      },
    },
  ],
})
export class HeroSectionComponent implements OnInit {
  private readonly routerService = inject(RouterService);
  private readonly filterService = inject(FilterService);

  ngOnInit() {
    this.filterService.resetFilters();
  }

  onSubmit() {
    return this.routerService.navigate(['/courses']);
  }
}
